import { render, staticRenderFns } from "./BaseSortIcons.vue?vue&type=template&id=3908faea&scoped=true&"
import script from "./BaseSortIcons.vue?vue&type=script&lang=ts&"
export * from "./BaseSortIcons.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSortIcons.vue?vue&type=style&index=0&id=3908faea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3908faea",
  null
  
)

export default component.exports